__turbopack_context__.v({
  "feedContainer": "Donations-module__DYAr_W__feedContainer",
  "iconContainer": "Donations-module__DYAr_W__iconContainer",
  "newDonationsButton": "Donations-module__DYAr_W__newDonationsButton",
  "newDonationsContainer": "Donations-module__DYAr_W__newDonationsContainer",
  "newDonationsContent": "Donations-module__DYAr_W__newDonationsContent",
  "newDonationsText": "Donations-module__DYAr_W__newDonationsText",
  "noNewDonations": "Donations-module__DYAr_W__noNewDonations",
  "onBottom": "Donations-module__DYAr_W__onBottom",
  "onTop": "Donations-module__DYAr_W__onTop",
  "scrollContainer": "Donations-module__DYAr_W__scrollContainer",
  "staticContainer": "Donations-module__DYAr_W__staticContainer",
  "staticFeedContainer": "Donations-module__DYAr_W__staticFeedContainer",
});
